import styled from 'styled-components';

import { SPACING } from '~/common/layout-propertis/spacing';

export const MobileHeaderContainer = styled.header`
  height: ${SPACING._40};
  min-height: ${SPACING._40};
  max-height: ${SPACING._40};
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
  padding: ${SPACING._16};
  margin-top: ${SPACING._16};
`;

export const IconAndTitle = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._8};
`;

export const RightContent = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: ${SPACING._8};
`;
